import { render, staticRenderFns } from "./StoreChartLists.vue?vue&type=template&id=20b8fc10"
import script from "./StoreChartLists.vue?vue&type=script&lang=js"
export * from "./StoreChartLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports